import { Typography, useTheme } from '@mui/material';
import { LONG_DATE_FORMAT } from '@npi/buddy-utils';

import { Card } from 'src/components';
import InvoiceHistoryTable from 'src/pages/ViewSalesInvoicePage/components/InvoiceHistory/InvoiceHistoryTable';
import { formatDate } from 'src/utils/utils';
import { selfBillingInvoice } from 'types/graphql';

const InvoiceHistory = ({
    invoice,
    currencySymbol, // To use in future development
}: {
    invoice: selfBillingInvoice['selfBillingInvoice'];
    currencySymbol: string;
}) => {
    const theme = useTheme();
    return (
        <Card color={theme.palette.text.primary} flex={1} gap="24px">
            <Typography fontSize="20px" fontWeight="500" lineHeight="30px">
                Invoice History
            </Typography>

            <InvoiceHistoryTable
                historyLogs={[
                    {
                        invoiceDate: formatDate({
                            date: new Date(invoice.createdAt),
                            format: LONG_DATE_FORMAT,
                        }),
                        description: 'Invoice created',
                        user: '', // No user associated with automated self-billing invoice creation
                    },
                ]} // Rest of the history logs will be added in future development
            />
        </Card>
    );
};
export default InvoiceHistory;
